import { render, staticRenderFns } from "./TrackOrder.vue?vue&type=template&id=2d230c22&scoped=true&"
import script from "./TrackOrder.vue?vue&type=script&lang=js&"
export * from "./TrackOrder.vue?vue&type=script&lang=js&"
import style0 from "./TrackOrder.vue?vue&type=style&index=0&id=2d230c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d230c22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCol,VContainer,VRow})
